import { createContext } from 'react';

export const linkFormContext = createContext({});
